import { createContext } from 'react'

export const RadioGroupContext = createContext()

export const RadioContext = createContext()
